<template>
  <div class="flex flex-col h-screen">
    <Header
      v-on:toggleMenu="toggleMenu"
      v-on:logout="logout"
      :isSideDrawerOpen="this.isSideDrawerOpen"
      :applicationLevel="this.getApplicationLevel()"
    />
    <main
      class="w-full max-w-4xl m-auto px-4 py-8 flex-1 items-start md:flex-row"
    >
      <transition mode="out-in">
        <section>
          <StepsHelper :applicationLevel="this.getApplicationLevel()" />
          <slot />
        </section>
      </transition>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/Layout/Authenticated/Header/Header.vue";
import Footer from "@/Layout/Authenticated/Footer/Footer.vue";
import StepsHelper from "./StepsHelper.vue";
import { getApplicationLevel } from "@/helpers.js";

export default {
  name: "Layout",
  components: {
    Header,
    Footer,
    StepsHelper,
  },
  data() {
    return {
      isSideDrawerOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isSideDrawerOpen = !this.isSideDrawerOpen;
    },
    async logout() {
      this.$store.dispatch("logUserOut");
      this.$router.push({ name: "Login" });
    },
    getApplicationLevel() {
      return getApplicationLevel(this.$store.state.user);
    },
  },
  computed: {
    route() {
      return this.$route.name;
    },
  },
  watch: {
    $route() {
      this.isSideDrawerOpen = false;
    },
  },
};
</script>
